import React, {useState} from 'react'
import {Action, Workflow, WorkflowConfig} from 'yougile-model'
import {Button} from '@components/common/button/button'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {ActionForm} from '../workflow-components'

export const ActionButton = (props: {
  workflow: Workflow
  config: WorkflowConfig
  action: Action
  onSubmit: (text: string | undefined, inputs: {[id: string]: unknown}) => void
  showTitle?: boolean
}) => {
  const {action, onSubmit, showTitle} = props
  const [open, setOpen] = useState(false)
  const click = () => setOpen(true)
  const close = () => setOpen(false)
  const create = (text: string, inputs: {[id: string]: any}) => {
    if (text || !showTitle) {
      onSubmit(text, inputs)
    }
    close()
  }
  return (
    <Dropdown
      visible={open}
      onVisibleChange={close}
      content={
        <ActionForm showTitle={showTitle} {...props} onSubmit={create} />
      }
    >
      <Button className="mr-8" onClick={click}>
        {action.name}
      </Button>
    </Dropdown>
  )
}
